<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Stat,
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
      statData: [
        { type: "line", title: "Total de assinantes", value: "-", icon: "bx-purchase-tag-alt", },
      ],

      total: 0,

      fields: [
        { key: "name", label: "Nome" },
        { key: "cellphone", label: "Celular" },
        { key: "plan", label: "Plano" },
        { key: "value", label: "Valor" },
        { key: "status", label: "Status" },
      ],
      items: null,

      sortBy: "name",
      sortDesc: false,
      currentPage: "1",
      perPage: "25",
    };
  },
  methods: {
    getClients() {
      this.items = null;

      api
        .get("subscriptions/clients")
        .then((response) => {
          if (response.data.status == "success") {
            this.total = response.data.total;
            this.items = response.data.list;

            this.statData = [
              { type: "line", title: "Total de assinantes", value: this.total.toString(), icon: "bx-purchase-tag-alt", },
            ];
          } else {
            this.total = 0;
            this.items = [];
          }
        })
        .catch((error) => {
          if (error) {
            this.total = 0;
            this.items = [];
          }
        })
    },
    /** Link wa.me alinhado ao padrão da API (Sales.php): Brasil + DDD + número */
    whatsappUrl(cellphone) {
      if (!cellphone) {
        return "";
      }
      let digits = String(cellphone).replace(/\D/g, "");
      if (!digits) {
        return "";
      }
      if (digits.startsWith("55")) {
        return "https://wa.me/" + digits;
      }
      return "https://wa.me/55" + digits;
    },
  },
  mounted() {
    this.getClients();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Assinaturas</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Assinantes</h3>
        <p>Clientes que realizaram assinatura do plano</p>
      </div>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-6 col-lg-4 col-xl-4">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div v-if="!items" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div class="card" v-else-if="items && items.length == 0">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum assinante encontrado
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <b-table :items="items" :fields="fields" class="table-nowrap table-style table-hover min-vh-25" head-variant="light" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            :current-page="currentPage" :per-page="perPage" responsive>
            <template #cell(cellphone)="row">
              <span v-if="!row.item.cellphone" class="text-muted">—</span>
              <span v-else class="d-inline-flex align-items-center flex-wrap">
                <span>{{ row.item.cellphone }}</span>
                <a
                  v-if="whatsappUrl(row.item.cellphone)"
                  class="btn btn-success ml-2 p-2"
                  :href="whatsappUrl(row.item.cellphone)"
                  target="_blank"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263">
                    </path>
                  </svg>
                </a>
              </span>
            </template>
            <template #cell(value)="row">
              {{ row.item.value | currency }}
            </template>
            <template #cell(status)="row">
              <span class="badge badge-status bg-soft-success" v-if="row.item.status == 'active'">Ativo</span>
              <span class="badge badge-status bg-soft-warning" v-else-if="row.item.status == 'suspended'">Suspenso</span>
              <span class="badge badge-status bg-soft-danger" v-else-if="row.item.status == 'overdue'">Inadimplente</span>
              <span class="badge badge-status bg-soft-secondary" v-else-if="row.item.status == 'canceled_client'">Cancelado pelo cliente</span>
              <span class="badge badge-status bg-soft-secondary" v-else-if="row.item.status == 'canceled_overdue'">Cancelado por inadimplência</span>
              <span class="badge badge-status bg-soft-info" v-else-if="row.item.status == 'await_plan'">Aguardando plano</span>
              <span class="badge badge-status bg-soft-info" v-else-if="row.item.status == 'plan_chosen'">Plano escolhido</span>
              <span class="badge badge-status bg-soft-info" v-else-if="row.item.status == 'await_payment'">Aguardando pagamento</span>
              <span class="badge badge-status bg-soft-info" v-else-if="row.item.status == 'payment_processing'">Processando pagamento</span>
              <span class="badge badge-status bg-soft-warning" v-else-if="row.item.status == 'payment_pending'">Pagamento pendente</span>
              <span class="badge badge-status bg-soft-warning" v-else-if="row.item.status == 'payment_change'">Troca de pagamento</span>
              <span class="badge badge-status bg-soft-secondary" v-else-if="row.item.status == 'inactive'">Inativo</span>
              <span class="badge badge-status bg-soft-secondary" v-else>{{ row.item.status }}</span>
            </template>
            <template #cell(date_actived)="row">
              {{ row.item.date_actived }}
            </template>
          </b-table>
        </div>

        <b-pagination class="mt-3" v-model="currentPage" :total-rows="total" :per-page="perPage" pills align="center"></b-pagination>
      </div>
    </div>
  </Layout>
</template>
